export default "__VITE_ASSET__B3oQ2SoJ__"